import { Button, Col, Row } from "reactstrap";
import styles from "src/components/Common/UI/MultiStepWizard/MultiStepWizard.module.css";

const EstablishmentNodeView = ({
  userID,
  toggleEdit,
  closeWizard,
  interfaceData,
}: EstablishmentNodeViewPros) => {


  return (
    <>
    
        <div className={`${styles.stepCard}`}>
          <Row>

            <Col xs="2">
              <label>Κόμβος</label>
            </Col>
            <Col xs="10">
              <p>{interfaceData.nodeID}</p>
            </Col>

  
            <Col xs="12">
              <Button onClick={toggleEdit}>Edit</Button>
            </Col>
            
          </Row>
        </div>
      
    </>
  )
}

export default EstablishmentNodeView;

type EstablishmentNodeViewPros = {
  userID?: number;
  toggleEdit: () => void;
  closeWizard: () => void;
  interfaceData: IEstablishmentInterfaceForm
}